import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import NewProductForm from "../../components/form/products/NewProductForm";
import PageMeta from "../../components/common/PageMeta";
import { useState } from "react";
import { useNavigate } from "react-router";

export default function NewProduct() {
    const navigate = useNavigate();
    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("");
    const [notificationType, setNotificationType] = useState<"success" | "error">("success");

    // Função para mostrar notificação
    const displayNotification = (message: string, type: "success" | "error") => {
        setNotificationMessage(message);
        setNotificationType(type);
        setShowNotification(true);

        // Auto-esconder após 5 segundos
        setTimeout(() => {
            setShowNotification(false);
        }, 5000);
    };

    // Callbacks para o formulário
    const handleSuccess = (_data: any) => {
        // Primeiro mostrar a notificação de sucesso
        displayNotification("Produto criado com sucesso!", "success");
        
        // Aguardar 1 segundo antes de redirecionar
        setTimeout(() => {
            navigate("/products");
        }, 1000);
    };

    const handleError = (error: any) => {
        // Mostrar mensagem de erro
        if (error.response && error.response.data && error.response.data.message) {
            displayNotification(error.response.data.message, "error");
        } else {
            displayNotification("Ocorreu um erro ao criar o produto. Por favor, tente novamente.", "error");
        }
    };

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate("/products");
    };

    return (
        <div>
            <PageMeta
                title="Novo Produto | Sellyo"
                description="Cadastro de produto"
            />
            <PageBreadcrumb 
                pageTitle="Novo Produto" 
                showBackButton={true}
                onBack={handleGoBack}
            />
            <div className="space-y-6">
                <NewProductForm onSuccess={handleSuccess} onError={handleError} />
            </div>

            {/* Componente de notificação */}
            {showNotification && (
                <div className={`fixed top-4 right-4 z-50 rounded-md p-4 shadow-md transition-all duration-300 ${notificationType === "success"
                    ? "bg-success-500 dark:bg-success-400 text-white"
                    : "bg-danger-500 dark:bg-danger-400 text-white"
                    }`}>
                    <div className="flex items-center">
                        {notificationType === "success" ? (
                            <svg
                                className="h-5 w-5 mr-2 text-white dark:text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        ) : (
                            <svg
                                className="h-5 w-5 mr-2 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        )}
                        <span>{notificationMessage}</span>
                    </div>
                </div>
            )}
        </div>
    );
}
